<template>
    <section style="margin-top: 45px">

        <div class="container-fluid">
        </div>
        <div class="container-fluid" style="margin-top: 15px">
            <div class="col-md-12">
                <div style="height: 30px">
                    <div class="status" style="">
                        <span style="float: right; margin-right: 5px; margin-top: -1px;" class="info-text">
                            <a href="" v-on:click.prevent="clearStatus">CLOSE</a>
                        </span>
                        <div class="text-center">
                            <div class="status-text"></div>
                        </div>
                    </div>
                    <div class="text-center">
                        <div class="error" style="color: red; font-size: 12px;"></div>
                    </div>
                </div>
            </div>

        </div>


        <div class="container-fluid" style="margin-top: 20px">
            <div class="col-md-6">
                <span class="box-label" data-intro='Write your Markdown here'>MARKDOWN</span>

                <span style="float: right; margin-left: 2px" class="info-text">
                    <a href="" v-on:click.prevent="clear">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>&nbsp;Clear</a>
                </span>
                <span style="float: right" class="info-text hidden-xs" data-toggle="tooltip" data-placement="left" title="Tooltip on left">
                    <a href="" id="whatIsMarkdown" class="pop" data-title="What is Markdown?" data-content="Markdown is a lightweight markup language with plain text formatting syntax. Markdown is often used to format readme files, to write messages in online discussion forums, and to create rich text using a plain text editor. Markdown is easily converted to HTML.<br/><br/>For more information, please see:<br/><br/><a href='https://en.wikipedia.org/wiki/Markdown'>https://en.wikipedia.org/wiki/Markdown</a><br><br><a href='https://help.github.com/articles/basic-writing-and-formatting-syntax'>https://help.github.com/articles/basic-writing-and-formatting-syntax</a><br><br>"
                        data-placement="bottom">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>&nbsp;What is Markdown?</a>
                </span>
                <!-- <span style="float: right;" class="info-text"><a href="" v-on:click.prevent="whatIsMarkdown">What is Markdown?</a></span> -->

                <textarea id="markdown" style="width: 100%;" v-model="myInput" @input="update"></textarea>
            </div>
            <div class="col-md-6">

                <span class="box-label" data-intro='View your document updates in real-time as you type.'>RESULT</span>
                <span style="float: right; margin-left: 2px" class="info-text">
                    <!-- <a href="" v-on:click.prevent="showHTML">Show HTML</a> -->
                    <a href="" v-on:click.prevent="showHTML" data-intro='View your formatted HTML at any time' data-position="left">
                        <i class="fa fa-file-code-o" aria-hidden="true"></i>&nbsp;RAW HTML</a>
                </span>




                <div id="results" class="markdown-body" v-html="compiledMarkdown" v-on:change="areaChange"></div>

            </div>

        </div>


        <div class="container-fluid" style="margin-top: 40px; margin-bottom: 50px">

            <div class="col-md-6">
                <div class="well text-center" style="height: 160px;" data-intro='Have your own Markdown (.md) file? Load it right here.'
                    data-position="top">
                    <h4 class="option-button">Load Markdown (.md)</h4>
                    <div style="margin-top: 20px">
                        <input type="file" class="custom-file-input" id="fileInput" v-on:change="loadMd">
                    </div>

                </div>


            </div>

            <!-- <div class="col-md-4">
            <div class="well text-center" style="height: 160px;" data-intro="Your markdown is automatically saved every 15 seconds to your browser's local storage.<br><br><strong>Manual load/save:</strong><ul><li><strong>CTRL-S:</strong> Save to local storage</li><li><strong>CTRL-L:</strong> Load from local storage</li></ul>" data-position="top">



                <h4 class="option-button">Local Storage</h4>
                <div style="margin-top: 20px">
              <button v-on:click="loadLocalStorage" class="btn btn-default btn-save">Load </button>
            <button v-on:click="saveLocalStorage" class="btn btn-default btn-save">Save </button>
            <p style="color: red; font-size: 10px; font-weight: 700; margin-top: 15px;" id="auto-save"></p>
          </div>


            </div>


        </div> -->




            <div class="col-md-6">
                <div class="well text-center" style="height: 160px;" data-intro="Ready to export? Save as html, markdown, or plain text.<br><br>Note: All formatting is removed when saved as plain text."
                    data-position="top">
                    <h4 class="option-button">Save Result As ...</h4>
                    <div style="margin-top: 20px">
                        <div class="row">
                            <div class="col-md-6">
                                <button v-on:click.stop.prevent="saveMd" class="btn btn-default btn-save first">Markdown (.md)</button>
                                <button v-on:click.stop.prevent="saveTxt" class="btn btn-default btn-save">Plain Text (.txt)</button>

                            </div>

                            <div class="col-md-6">
                                <button v-on:click.stop.prevent="saveStyledHtml" class="btn btn-default btn-save first">Styled (.html)</button>
                                <button v-on:click.stop.prevent="saveRawHtml" class="btn btn-default btn-save">Raw (.html)</button>
                                <!-- <button v-on:click.stop.prevent="saveExperimental" class="btn btn-default btn-save">Experimental (.md)</button> -->

                            </div>
                        </div>


                    </div>
                    <!-- <input type="file" id="fileInput" v-on:change="loadMd"> -->




                </div>


            </div>





        </div>

        </div>


        <!-- Modal -->





    </section>
</template>

<script>

    const md = require('markdown-it')({
        html: true,
        linkify: true,
        typographer: true
    });
    md.use(require('markdown-it-footnote'));
    md.use(require("markdown-it-fontawesome"));
    md.use(require("markdown-it-attrs"))
    md.use(require("markdown-it-katex"))
    // md.use(require("markdown-it-github-headings"))
    md.use(require('markdown-it-named-headers'));

    import moment from 'moment'
    import {
        boilerplateMap
    } from '../boilerplates'
    import {
        EventBus
    } from '@/event-bus';
    import {
        defaultTemplate
    } from '@/templates/default'
    import router from '../router'
    import axios from 'axios';


    const removeMd = require('remove-markdown');
    const beautify_html = require('js-beautify').html;
    const lil = require('lil-uuid')
    var FileSaver = require('file-saver');

    function syncScroll(el1, el2) {
        var $el1 = $(el1);
        var $el2 = $(el2);

        // Lets us know when a scroll is organic
        // or forced from the synced element.
        var forcedScroll = false;

        // Catch our elements' scroll events and
        // syncronize the related element.
        $el1.scroll(function () {
            performScroll($el1, $el2);
        });
        $el2.scroll(function () {
            performScroll($el2, $el1);
        });

        // Perform the scroll of the synced element
        // based on the scrolled element.
        function performScroll($scrolled, $toScroll) {
            if (forcedScroll) return (forcedScroll = false);
            var percent = ($scrolled.scrollTop() /
                ($scrolled[0].scrollHeight - $scrolled.outerHeight())) * 100;
            setScrollTopFromPercent($toScroll, percent);

        }

        // Scroll to a position in the given
        // element based on a percent.
        function setScrollTopFromPercent($el, percent) {
            var scrollTopPos = (percent / 100) *
                ($el[0].scrollHeight - $el.outerHeight());
            forcedScroll = true;
            $el.scrollTop(scrollTopPos);
        }
    }

    // function download(filename, text, ext) {
    //     var pom = document.createElement('a');
    //     pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    //     pom.setAttribute('download', filename + ext);
    //
    //     if (document.createEvent) {
    //         var event = document.createEvent('MouseEvents');
    //         event.initEvent('click', true, true);
    //         pom.dispatchEvent(event);
    //     } else {
    //         pom.click();
    //     }
    // }


    export default {
        data() {
            return {
                myInput: '',
                fileTitle: '',
                selected: '',
                localStorage: false,

                linkData: '',
                errors: [],
                apiBase: '',
                responseData: '',
                test: '',
                siteBase: '',
                copyData: '',

            }
        },
        name: 'Home',
        props: {
            plink: {
                type: String,
                default: ''
            }
        },
        mounted: function () {

            this.loadLocalStorage();



            // Event bus
            EventBus.$on('load-boilerplate', (bp) => {
                console.log('Load boilerplate: ' + bp)
                //$('#status').html('Load boilerplate: ' + bp)
                //console.log(boilerplateMap[0]["selectName"])
                let myObj = _.find(boilerplateMap, ['selectName', bp]);
                this.myInput = myObj["body"]
            });

            EventBus.$on('load-markdown', (md) => {
                console.log('Load markdown: ' + md)
                vm.myInput = md;
            });

            let vm = this



            // if (typeof localStorage !== 'undefined') {
            //     this.localStorage=true;
            // } else {
            //     this.localStorage=false;
            // }

            $('a.pop').webuiPopover();



            $(document).ready(function () {


                syncScroll($('.markdown-body '), $('#markdown'));

                // Load default document in local storage if it exists.

                if (vm.link === '') {
                    if (localStorage.getItem("mdTemp") === null) {
                        vm.myInput = boilerplateMap[0].body

                    } else {
                        vm.myInput = localStorage.getItem('mdTemp');

                    }
                }

            });


            // set default title
            let myFileTile = moment().format('DD-MM-YYYY').replace(/\s+/g, '');
            vm.fileTitle = 'saveFile' + myFileTile

            $(document).keydown(function (event) {
                // If Control or Command key is pressed and the S key is pressed
                // run save function. 83 is the key code for S.


                if ((event.ctrlKey || event.metaKey) && event.which == 83) {
                    // Ctrl-S saves to local storage.
                    let myMd = $('#markdown').val();
                    localStorage.setItem('mdTemp', myMd);
                    //$('#status').html('Saved: local storage')
                    //vm.updateStatus("STATUS", "Saved to local storage.")
                    event.preventDefault();
                    return false;
                };

                // https://css-tricks.com/snippets/javascript/javascript-keycodes/
                if ((event.ctrlKey || event.metaKey) && event.which == 76) {
                    // Ctrl-L loads from local storage
                    let myMd = localStorage.getItem('mdTemp');
                    vm.$emit('loadFile', myMd);

                    event.preventDefault();
                    return false;
                };

            });


            window.setInterval(function () {
                var time = new Date();
                //console.log(time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds());
                let myMd = $('#markdown').val();
                //console.log(myMd)
                localStorage.setItem('mdTemp', myMd);
                let message = 'Auto saved to local storage: ' + moment().format("h:mm:ss a");
                //$('#auto-save').html(message)
                console.log(message)
            }, 15000);




        },
        methods: {
            // saveExperimental: function () {
            //   var blob = new Blob([this.myInput], {type: "text/plain;charset=utf-8"});
            //   FileSaver.saveAs(blob, "Markdown.md");
            // },
            downloadFile: function (filename, text, ext) {
                var blob = new Blob([text], { type: "text/plain;charset=utf-8" });
                FileSaver.saveAs(blob, filename + ext);
            },
            showHTML: function () {
                this.updateStatus("", "Show Raw HTML")
                let results = '<pre><xmp>' + beautify_html($('.markdown-body ').html()) + '</xmp></pre>'
                var options = {
                    message: results,
                    title: 'HTML',
                    size: eModal.size.xl
                };
                eModal.alert(options);
                //console.log($('.markdown-body ').html())
            },

            areaChange: function () {
                console.log('Change')
            },
            updateMd: function () {
                this.myInput = 'loaded'
            },
            clear: function () {
                this.myInput = ''
                this.selected = ''
                this.updateStatus("", "Markdown cleared")
            },

            update: function () {
                _.debounce(function (e) {
                    this.myInput = e.target.value
                }, 300)
            },
            saveMd: function () {
                this.downloadFile(this.fileTitle, this.myInput, '.md');
                this.updateStatus("STATUS", "Saved markdown file.")

            },

            reRender: function () {
                console.log('reRender')
            },

            loadMd: function (e) {
                let vm = this;
                let fileInput = document.getElementById('fileInput');
                let markdownDiv = document.getElementById('markdown');
                let file = fileInput.files[0];
                vm.fileTitle = file.name
                vm.fileTitle = vm.fileTitle.replace(/\.[^/.]+$/, "")
                //console.log('Filename: ', vm.fileTitle)

                this.updateStatus("", "Load external file.")
                // set context

                // need to implement file-type check here
                if (true) {
                    let reader = new FileReader();
                    //Filereader: https://developer.mozilla.org/en-US/docs/Web/API/FileReader
                    reader.onload = function (e) {

                        EventBus.$emit('load-markdown', reader.result);
                    }
                    reader.readAsText(file);
                } else {
                    fileDisplayArea.innerText = "File not supported!"
                }

            },
            saveRawHtml: function () {

                //console.log('Save html:')
                //console.log($('.markdown-body ').html())

                this.downloadFile(this.fileTitle, beautify_html($('.markdown-body ').html()), '.html');
                this.updateStatus("", "Saved raw HTML.")

            },
            saveStyledHtml: function () {
                //$('#status').html('Saved to styled html')
                //console.log('Save html:')
                //console.log($('.markdown-body ').html())
                let myHTML = $('.markdown-body ').html();
                // let styledHTML = `<html><head></head><body>${myHtml}</body></html>`
                //console.log(defaultTemplate(myHTML))
                this.downloadFile(this.fileTitle, beautify_html(defaultTemplate(myHTML)), '.html');
                this.updateStatus("", "Saved styled HTML.")

            },
            saveTxt: function () {

                const plainText = removeMd(this.myInput);
                //console.log(plainText)
                this.downloadFile(this.fileTitle, plainText, '.txt');
                this.updateStatus("", "Saved plain text.")

            },
            saveLocalStorage: function () {
                localStorage.setItem('mdTemp', this.myInput);
                //console.log(this.myInput)
                this.updateStatus("", "Saved to local storage.")
            },
            changeSelect: function () {
                $('#status').html('Load boilerplate: ' + this.selected)
                //console.log(boilerplateMap[0]["selectName"])
                let myObj = _.find(boilerplateMap, ['selectName', this.selected]);
                this.myInput = myObj["body"]
            },
            loadLocalStorage: function () {

                let content = localStorage.getItem('mdTemp');
                //console.log(content)
                this.myInput = content;
            },

            updateStatus: function (title, body) {
                let t = '<span style="margin-bottom: 15px; text-transform: uppercase"><b>' + title + '</b></span>&nbsp;&nbsp;'
                let b = body
                $('.status').show();
                $('.status-text').html(t + b)
                setTimeout(function () {
                    $('.status').hide();
                    $('.status-text').html('')
                }, 3000);

            },


            clearStatus: function () {
                $('.status').hide()
            },


        },

        computed: {
            compiledMarkdown: function () {
                return md.render(this.myInput)

            }
        }
    }
</script>

<style>
    #markdown {
        height: 800px;
        vertical-align: top;
        box-sizing: border-box;
        padding: 0 20px;
        border: none;
        border: 1px solid #ccc;
        resize: none;
        outline: none;
        background-color: #f6f6f6;
        font-size: 14px;
        padding: 20px;
        width: 100%;
    }

    .markdown-body {
        font-family: 'Lato', sans-serif
    }

    #results {
        height: 800px;
        overflow: auto;
        vertical-align: top;
        box-sizing: border-box;
        padding: 15px 20px;
        border: none;
        border: 1px solid #ccc;
        resize: none;
        outline: none;
        width: 100%;
    }

    code {
        color: #f66;
    }

    .webui-popover {
        max-width: 500px;
    }

    .info-text {
        font-weight: 900;
        color: #000;
        font-size: 10px;
        text-transform: uppercase;
        background: #ccc;
        padding: 2px 5px 2px 5px;
        margin-top: 12px
    }

    .info-text a:hover {
        color: #fff !important;
    }

    .info-text:hover {
        background: #aaa
    }

    .box-label {
        font-weight: 900;
        font-size: 24px
    }

    .option-button {
        text-transform: uppercase;
        font-size: 14px;
        font-weight: 900
    }

    .markdown-body table {
        border-collapse: collapse;
        text-align: left;
        width: 100% !important;
        margin-bottom: 20px;
        display: inline-table;
    }

    .markdown-body table td,
    .markdown-body table th {
        padding: 3px 10px;
    }

    .markdown-body table thead th {
        background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #8C8C8C), color-stop(1, #7D7D7D));
        background: -moz-linear-gradient( center top, #8C8C8C 5%, #7D7D7D 100%);
        filter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#8C8C8C', endColorstr='#7D7D7D');
        background-color: #8C8C8C;
        color: #FFFFFF;
        font-size: 15px;
        font-weight: bold;
        border-left: 1px solid #A3A3A3;
    }

    .markdown-body table thead th:first-child {
        border: none;
    }

    .markdown-body table tbody td {
        color: #7D7D7D;
        border-left: 1px solid #DBDBDB;
        font-size: 12px;
        font-weight: normal;
    }

    .markdown-body table tbody .alt td {
        background: #EBEBEB;
        color: #7D7D7D;
    }

    .markdown-body table tbody td:first-child {
        border-left: none;
    }

    .markdown-body table tbody tr:last-child td {
        border-bottom: none;
    }

    .markdown-body table tfoot td div {
        border-top: 1px solid #8C8C8C;
        background: #EBEBEB;
    }

    .markdown-body table tfoot td {
        padding: 0;
        font-size: 12px
    }

    .markdown-body table tfoot td div {
        padding: 2px;
    }

    .markdown-body table tfoot td ul {
        margin: 0;
        padding: 0;
        list-style: none;
        text-align: right;
    }

    .markdown-body table tfoot li {
        display: inline;
    }

    .markdown-body table tfoot li a {
        text-decoration: none;
        display: inline-block;
        padding: 2px 8px;
        margin: 1px;
        color: #F5F5F5;
        border: 1px solid #8C8C8C;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        background: -webkit-gradient( linear, left top, left bottom, color-stop(0.05, #8C8C8C), color-stop(1, #7D7D7D));
        background: -moz-linear-gradient( center top, #8C8C8C 5%, #7D7D7D 100%);
        filter: progid: DXImageTransform.Microsoft.gradient(startColorstr='#8C8C8C', endColorstr='#7D7D7D');
        background-color: #8C8C8C;
    }

    .markdown-body table tfoot ul.active,
    .markdown-body table tfoot ul a:hover {
        text-decoration: none;
        border-color: #7D7D7D;
        color: #F5F5F5;
        background: none;
        background-color: #8C8C8C;
    }

    .markdown-body h1,
    .markdown-body h2,
    .markdown-body h3,
    .markdown-body h4,
    .markdown-body h5 {
        margin-bottom: 20px;
    }

    .markdown-body img {
        margin-bottom: 40px;
    }

    .fa-2x {
        vertical-align: middle;
    }

    .btn-save {
        font-weight: 900;
        font-size: 12px;
        margin-top: 10px;
        text-transform: uppercase;
    }

    .btn-save.first {
        margin-top: 0px;
    }

    .status {
        display: none;
        border: 1px solid #ddd;
        background: #eee;
        padding-top: 5px;
        padding-bottom: 5px
    }

    .status-text {
        font-size: 12px;
        font-weight: 700;
    }

    /*#results, #markdown {padding-bottom: 200px;}*/
</style>


// WEBPACK FOOTER //
// Home.vue?b4d33662